export default __webpack_public_path__ + "static/jspl-obj-e59d3ee7793a52596f327035934d06e0.png";